// CSS
import '../scss/index.scss';

// Vendors
import $ from 'jquery';
import './lib/wl-share';

// Framework
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/mobile-nav';
import './site/side-nav';
import './site/video-modals';
import './site/image-lightbox';
import './site/timeline';
import './site/county-map';
import './site/tabbed-content';
import './site/print-post';
import stickyHeader from './site/sticky-header';
import pageHeroSlider from './site/page-hero-slider';
import imageCarousel from './site/image-carousel';
import scrollReveal from './site/scroll-reveal';

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');

// Init sticky-header shadow toggle
stickyHeader();

// Init page-hero slider crossfade
pageHeroSlider();

// Init image-section carousels
imageCarousel();

// Init scroll-reveal observer (any element with `data-reveal`)
scrollReveal();
